import router from "../../router";
import { db, firestore } from "../../firebase.config";

const state = {};

const mutations = {};

const actions = {
  resetAppState({ commit }) {
    commit("SET_PROFILE", null);
    commit("SET_COMPANY", null);
    commit("SET_OBJECTIVES", []);
    commit("SET_KEY_RESULTS", []);
  },
  test({ dispatch }) {
    let notification = {
      title: "Notification title",
      message: "Check your connection and try again",
      type: "warning-important",
      icon: "activity",
    };
    dispatch("fireNotification", notification);
  },
  blur(context, event) {
    event.target.blur();
  },
  select(context, event) {
    event.target.select();
  },
  async runAction({ dispatch }, action) {
    function runThenAction(thenDo, payload) {
      if (payload) {
        dispatch(thenDo, payload);
      } else {
        dispatch(thenDo);
      }
    }

    if (action.route) {
      router.push(action.route);
      return;
    } else if (action.payload) {
      await dispatch(action.do, action.payload);
      if (action.then) runThenAction(action.then, action.thenPayload);
    } else {
      await dispatch(action.do);
      if (action.then) runThenAction(action.then, action.thenPayload);
    }
  },
  async getData({ dispatch, commit }, user) {
    commit("SET_SIGNING_IN", true);
    const userData = await dispatch("getUserProfile", user);

    if (userData.companyId) {
      return Promise.all([
        dispatch("getCompany", userData.companyId),
        dispatch("getGoals", userData.companyId),
        dispatch("getTeammates", userData.companyId),
      ]).then(() => {
        return commit("SET_SIGNING_IN", false);
      });
    } else return commit("SET_SIGNING_IN", false);
  },
  reload() {
    location.reload();
  },
  goToTour() {
    window.location = "/?tour";
  },
  deleteDoc({ dispatch }, payload) {
    return db
      .collection(payload.collection)
      .doc(payload.id)
      .delete()
      .catch(() => {
        let notification = {
          title: "Couldn’t delete",
          message: "Please check your wifi and try again",
          type: "error",
          icon: "wifi-off",
        };
        dispatch("fireNotification", notification);
      });
  },
  updateDoc({ dispatch }, payload) {
    return db
      .collection(payload.collection)
      .doc(payload.id)
      .update(payload.item)
      .catch(() => {
        let notification = {
          title: "Couldn’t make the update",
          message: "Please check your wifi and try again",
          type: "error",
          icon: "wifi-off",
        };
        dispatch("fireNotification", notification);
      });
  },
  createDoc({ dispatch }, payload) {
    return db
      .collection(payload.collection)
      .add(payload.item)
      .catch(() => {
        let notification = {
          title: "Couldn’t create the document",
          message: "Please check your wifi and try again",
          type: "error",
          icon: "wifi-off",
        };
        dispatch("fireNotification", notification);
      });
  },
  arrayUnion({ dispatch }, payload) {
    return db
      .collection(payload.collection)
      .doc(payload.id)
      .update({
        [payload.array]: firestore.FieldValue.arrayUnion(payload.item),
      })
      .catch(() => {
        let notification = {
          title: "Couldn’t make the update",
          message: "Please check your wifi and try again",
          type: "error",
          icon: "wifi-off",
        };
        dispatch("fireNotification", notification);
      });
  },
  arrayDelete({ dispatch }, payload) {
    return db
      .collection(payload.collection)
      .doc(payload.id)
      .update({
        [payload.array]: firestore.FieldValue.arrayRemove(payload.item),
      })
      .catch(() => {
        let notification = {
          title: "Couldn’t make the update",
          message: "Please check your wifi and try again",
          type: "error",
          icon: "wifi-off",
        };
        dispatch("fireNotification", notification);
      });
  },
  currentQuarter() {
    const today = new Date();
    return Math.floor((today.getMonth() + 3) / 3);
  },
  currentYear() {
    const today = new Date();
    return today.getFullYear();
  },
};

const getters = {};

const utilitiesModule = {
  state,
  mutations,
  actions,
  getters,
};

export default utilitiesModule;
